module.exports = __webpack_public_path__ + "img/danarupiah.4a2fbfb2.jpg";